/**
 * <fiee-clock> — a live date/time island for the site header.
 *
 * The server renders a static fallback inside the element; once this component
 * hydrates it replaces the contents and ticks every second. Times are shown in
 * Lima local time regardless of the visitor's timezone.
 */
export class FieeClock extends HTMLElement {
  #timer: number | undefined;

  static readonly #dateFmt = new Intl.DateTimeFormat("es-PE", {
    weekday: "long",
    day: "2-digit",
    month: "long",
    year: "numeric",
    timeZone: "America/Lima",
  });

  static readonly #timeFmt = new Intl.DateTimeFormat("es-PE", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone: "America/Lima",
  });

  connectedCallback(): void {
    this.#render();
    this.#timer = window.setInterval(() => this.#render(), 1000);
  }

  disconnectedCallback(): void {
    if (this.#timer !== undefined) window.clearInterval(this.#timer);
  }

  #render(): void {
    const now = new Date();
    const raw = FieeClock.#dateFmt.format(now);
    const date = raw.charAt(0).toUpperCase() + raw.slice(1);

    const dateEl = document.createElement("span");
    dateEl.className = "clock__date";
    dateEl.textContent = date;

    const timeEl = document.createElement("time");
    timeEl.className = "clock__time";
    timeEl.dateTime = now.toISOString();
    timeEl.textContent = FieeClock.#timeFmt.format(now);

    this.replaceChildren(dateEl, timeEl);
  }
}
